import { refererDomain, refererURL } from "./url";

import Cookies from 'js-cookie'

const ENDPOINT = 'https://configurator.elitehts.com/email-api/send-selections.php'

class MailerClass{
    async sendEmail(data){
        var body = Object.assign({
          referer_domain: refererDomain(),
          referer_url: refererURL()
        }, data, this.getUtm());

        try {
            const response = await fetch(ENDPOINT, {
                method:'post',
                credentials: "same-origin",
                cache: "no-cache",
                mode: "cors",
                body: JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json'
                },
            }).then(r=>r.json());
            console.log(response);

            return response;
        } catch (err) {
            console.error(err);
            return err;
        }
    }

    readUtmFromCookie(){
      try {
        var json = JSON.parse(Cookies.get('saved_utms'));
        console.log(`UTM found in COOKIE`, json);

        if(Object.keys(json).length > 0){
          return json;
        }

      } catch (err) {
        return null;
      }
      return null;
    }

    getUtm(){
        var params = {};
        const parameters = new URLSearchParams(window.location.search)

        params['utm_source'] = parameters.get('utm_source') || '';
        params['utm_medium'] = parameters.get('utm_medium') || '';
        params['utm_campaign'] = parameters.get('utm_campaign') || '';
        params['utm_id'] = parameters.get('utm_id') || '';
        params['utm_term'] = parameters.get('utm_term') || '';
        params['utm_content'] = parameters.get('utm_content') || '';

        if(Object.keys(params).filter(p => !!params[p]).length === 0){
          var utms = this.readUtmFromCookie();
          if(utms){
            params = utms;
          }
        }

        return params;
    }
}

const Mailer = new MailerClass();
// window['Mailer'] = Mailer;

export {
    Mailer,
    MailerClass
}
